import { PrismicNextImage } from '@prismicio/next';
import { asText, Content, isFilled } from '@prismicio/client';

import {
  Box,
  Card,
  Heading,
  CardBody,
  CardHero,
  CardTitle,
  Typography,
  CardContent,
  CardFeature,
} from '@preventx/oxygen';

export type WithPriorityServiceProps = {
  slice: Content.RegionComplexSliceWithPriorityService;
};

/** **Environment Usage**
 *
 * - **Test Me** - As an Advertisement Slice on multiple pages */
export const WithPriorityService = ({ slice }: WithPriorityServiceProps) => {
  const { primary } = slice;

  const {
    title,
    image,
    subtitle,
    content_lede,
    content_eyebrow,
    content_disclaimer,
  } = primary;

  return (
    <CardFeature>
      <Card component="article" variant="dark">
        {isFilled.image(image) && (
          <CardHero component="div">
            <PrismicNextImage field={image} />
          </CardHero>
        )}

        <CardBody>
          <CardContent className="switcher">
            <Box component="div" addCluster className="cluster flex-nowrap">
              <Box component="div" className="clock"></Box>
              <Box component="div">
                <CardTitle component="h3">{asText(title)}</CardTitle>
                <Heading component="h4">{asText(subtitle)}</Heading>
              </Box>
            </Box>

            <Box component="div" addFlow>
              <Typography component="p" addEyebrow>
                {asText(content_eyebrow)}
              </Typography>

              <Typography component="p" className="lede">
                {asText(content_lede)}
              </Typography>

              <Typography component="p">
                <Typography component="small">
                  {asText(content_disclaimer)}
                </Typography>
              </Typography>
            </Box>
          </CardContent>
        </CardBody>
      </Card>
    </CardFeature>
  );
};
